module.exports = __webpack_public_path__ + "img/geology-mercury.88183e72.png";